import auth from "@api/auth";
import CustomAppleLogin from "./CustomAppleLogin";
import AppleLogin from 'react-apple-login';
import { getCookie } from "@utils/Cookies";
import { COOKIE_LOGIN_TOKEN_KEY } from "@utils/constants";
import { useRouter } from "next/router";
import { useUI } from "@context/ui-managed-context";
import { IUserLoginInput } from "@types";
import getConfig from "next/config";
const { publicRuntimeConfig } = getConfig();
interface AppleLoginProps {
  onLoad: (data: boolean) => void
  handleEvent: (data: IUserLoginInput, socialType: 'apple' | 'google' | 'facebook') => void
}

const AppleLoginBtn: React.FC<AppleLoginProps> = ({ onLoad, handleEvent }) => {
  const { reload } = useRouter();
  const { closeModal } = useUI();
  const appleResponse = async (response: any) => {
    if (!response.error) {
      onLoad(true)
      const data: any = {
        token: response?.authorization?.id_token || "",
        code: response?.authorization?.code || "",
      }
      if (response.user) {
        data.name = `${response.user?.name?.firstName || ""} ${response.user?.name?.lastName || ""}`
      }
      const res = await auth.appleLogin(data).fetch();
      getCookie().set(COOKIE_LOGIN_TOKEN_KEY, res.data.access_token, {}, 365);
      handleEvent(res.data, "apple")
      reload();
      closeModal()
      onLoad(false)
    }
  };
  return (
    <AppleLogin
      clientId={publicRuntimeConfig.APPLE_CLIENT_ID || "com.dabdoob.dabdoob"}
      redirectURI={publicRuntimeConfig.APPLE_REDIRECT_URI || "https://dev.dabdoob.cloud/apple"}
      responseType={"code"}
      responseMode={"query"}
      scope="email name"
      usePopup={true}
      callback={appleResponse}
      render={(e) => <CustomAppleLogin action={e} />} />
  );
}

export default AppleLoginBtn;